import { render, staticRenderFns } from "./Funnel.vue?vue&type=template&id=52c2c21d&"
import script from "./Funnel.vue?vue&type=script&lang=js&"
export * from "./Funnel.vue?vue&type=script&lang=js&"
import style0 from "./Funnel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports